import usePrivateAxios from '@/common/api/usePrivateAxios';
import { useMutation } from '@tanstack/react-query';

interface UseMarkBillingBillAsPaidProps {
  id?: string;
  onSuccess?: (response: any) => void;
  onError?: (response: any) => void;
}

export const useMarkBillingBillAsPaid = ({ id, onSuccess, onError }: UseMarkBillingBillAsPaidProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['markBillingBillAsPaid', id],
    mutationFn: async () => privateAxios.put(`/billing/bills/${id}/mark_as_paid`),
    onSuccess,
    onError,
  });
};